import type { ReceiptTemplate } from '../schema';

export const zaraTemplate: ReceiptTemplate = {
  id: 'zara',
  name: 'Zara Receipt',
  brand: 'ZARA',
  description: 'Fast fashion receipt template inspired by Zara stores',
  settings: {
    width: 280,
    font: 'Courier New',
    fontSize: 11,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#000000',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
  },
  sections: [
    {
      id: 'zara-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 50,
        businessName: 'ZARA',
        businessNameFontSize: 28,
        addressLines: [
          '666 Fifth Avenue',
          'New York, NY 10103',
          'Tel: 212-765-0477',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'zara-info',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'zara-ticket', label: 'Ticket:', value: '2025-0930-4521' },
          { id: 'zara-store', label: 'Store:', value: '1847' },
          { id: 'zara-register', label: 'Register:', value: '03' },
          { id: 'zara-date', label: 'Date:', value: '30/09/2025 16:33' },
        ],
        column2: [],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'zara-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        showQuantity: true,
        quantityPosition: 'left',
        showHeader: false,
        showHeaderDivider: false,
        headerLabels: {
          quantity: 'Qty',
          item: 'Article',
          amount: 'Price',
        },
        items: [
          { id: 'zara-item-1', quantity: '1', name: 'OVERSIZED BLAZER', price: '$89.90' },
          { id: 'zara-item-2', quantity: '2', name: 'BASIC T-SHIRT', price: '$25.90' },
          { id: 'zara-item-3', quantity: '1', name: 'WIDE LEG JEANS', price: '$49.90' },
        ],
        showTopDivider: false,
        showDivider: false,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'zara-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'left',
        labelPosition: 50,
        lines: [
          { id: 'zara-items-count', label: 'Items: 4', value: '', isBold: false, isLarge: false },
          { id: 'zara-subtotal', label: 'Subtotal', value: '191.60', isBold: false, isLarge: false },
          { id: 'zara-tax', label: 'Tax (8.875%)', value: '17.00', isBold: false, isLarge: false },
          { id: 'zara-total', label: 'TOTAL', value: '208.60', isBold: true, isLarge: true },
        ],
        increaseTotalSize: true,
        totalSizeIncrease: 30,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'zara-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        paymentType: 'card',
        cardFields: [
          { id: 'zara-card', label: 'MASTERCARD', value: '****7291' },
          { id: 'zara-paid', label: 'Amount Paid', value: '$208.60' },
          { id: 'zara-auth', label: 'Auth', value: '847521' },
        ],
        cashFields: [
          { id: 'zara-cash', label: 'Cash', value: '$220.00' },
          { id: 'zara-change', label: 'Change', value: '$11.40' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'zara-message',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'EXCHANGE/REFUND WITHIN 30 DAYS\nWITH RECEIPT AND TAGS ATTACHED\n\nThank you for shopping at ZARA\nzara.com',
        fontSize: 10,
        showDivider: false,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'zara-barcode',
      type: 'barcode',
      enabled: true,
      config: {
        alignment: 'center',
        type: 'code128',
        value: '202509304521',
        showValue: true,
        width: 1.4,
        height: 45,
        showDivider: false,
        dividerStyle: 'dashed',
      },
    },
  ],
};
